<template>
  <section class="band" id="inside">
    <div class="wrap">
      <div class="head c">
        <h2 class="h2">Take a look inside</h2>
      </div>
      <div class="tour-tabs mt" role="tablist" aria-label="Adverpost screens">
        <button type="button" data-k="ipam" role="tab">Private Booking</button>
        <button type="button" data-k="displays" role="tab">Displays and pricing</button>
        <button type="button" data-k="media" role="tab">Media Library</button>
        <button type="button" data-k="logs" role="tab">Booking Logs</button>
      </div>
      <div class="tour-stage">
        <div class="browser">
          <!-- Window dots only: the address pill is omitted, since the in-app paths
               are not meaningful to a visitor who is not signed in. -->
          <div class="bar"><i></i><i></i><i></i></div>
          <div class="tour-scroll"><div class="apx" id="tourScreen" role="img" aria-label="Adverpost platform screen"></div></div>
        </div>
      </div>
      <div class="tour-cap" id="tourCap"></div>
    </div>
  </section>
</template>

<script> 
// Extracted from the published landing page; in-page anchors emit instead of
// navigating, because the app uses a hash router.
export default { name: "InsideSection" };
</script>
